import { AppThunk } from '../../types';
import { setUsersAction, setUsersErrorAction, setUsersFetchStatusAction } from './reducer';
import { createFetchedSuccess, createFetchedWithError, createFetchInProgress } from 'types/rest/IFetchStatus';
import { IGetUser } from '../../../types/users/IUser';
import { getUsersAsync } from '../../../API/order/title/userAPI';

export const getUsers =
  (users: IGetUser[]): AppThunk =>
  async (dispatch) => {
    try {
      dispatch(setUsersErrorAction(null));
      dispatch(setUsersFetchStatusAction(createFetchInProgress()));
      const response = await getUsersAsync(users);
      dispatch(setUsersAction(response));
      dispatch(setUsersFetchStatusAction(createFetchedSuccess()));
    } catch (e: any) {
      dispatch(setUsersFetchStatusAction(createFetchedWithError()));
      dispatch(setUsersErrorAction(e.message));
    }
  };
